<div
  class="shape {{animated() ? animated() : ''}} color-{{color()}}"
  [class.animated]="!!animated()"
  [class.type]="type()"
  [style.height]="computedHeight()"
  [style.width]="width()"
  [style.border-radius]="computedRadius()"
></div>
